module.exports = __webpack_public_path__ + "static/20210908_190555-0f2f36d64ee686b7e9052da1d375c0f9.jpg";